<template>
  <div class="auth-layout">
    <section class="autorization-section auth-layout__content">
      <div class="autorization_wrapp">
        <div class="autorization_preview">
          <InlineSvg style="height: 530px" src="/img/cat_dog.svg"  />
        </div>
        <router-view></router-view>
      </div>
    </section>
  </div>
</template>

<script>
import { csrf } from "~/api/auth";

export default {
  async created() {
    await csrf();
  },

  methods: {}
};
</script>

<style scoped lang="scss">
.auth-layout {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.auth-layout__content {
  flex: 1;
  min-height: 0;
  display: flex;
}

.auth-layout__content .autorization_wrapp {
  width: 100%;
  min-height: 100%;
}
</style>
